/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useState, useContext } from 'react';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  FormFeedback,
  Card,
  CardBody,
} from 'reactstrap';
import { Formik, Field, Form as FormikForm, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { BsFillPencilFill, BsPlus, BsCurrencyRupee } from 'react-icons/bs';
import { toast } from 'react-toastify';
import axios from 'axios';
import { authContext } from 'contexts/AuthContext';
import '../IndianSellerCommission/style.css';

const DEFAULT_BUYER_COMMISSIONS = [
  {
    id: 1001,
    commissionTypeName: 'Global Commission',
    leastRangeRate: 0.25,
    midRangeRate: 0.25,
    maxRangeRate: 0.25,
    minWeight: 100000,
    maxWeight: 500000,
    isDefault: true,
  },
];

const validationSchema = Yup.object().shape({
  slabRange1: Yup.string().required('Slab range is required'),
  minRate: Yup.number()
    .typeError('Must be a number')
    .required('Rate is required'),
  midRate: Yup.number()
    .typeError('Must be a number')
    .required('Rate is required'),
  slabRange3: Yup.string()
    .required('Slab range is required')
    .test(
      'is-greater-than-min',
      'Max weight must be greater than min weight',
      (value, context) => {
        const minWeight = parseInt(
          context.parent.slabRange1.toString().replace(/,/g, ''),
          10,
        );
        const maxWeight = parseInt(value.toString().replace(/,/g, ''), 10);

        if (!Number.isNaN(minWeight) && !Number.isNaN(maxWeight)) {
          return maxWeight > minWeight;
        }

        return true;
      },
    ),
  maxRate: Yup.number()
    .typeError('Must be a number')
    .required('Rate is required'),
});

const AutoCalculateSlabRange = () => {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (values.slabRange1 && values.slabRange3 && values.isCreate) {
      const calculatedRange = `${values.slabRange1} - ${values.slabRange3}`;
      setFieldValue('slabRange2', calculatedRange);
    }
  }, [values.slabRange1, values.slabRange3, values.isCreate, setFieldValue]);

  return null;
};

const IconInput = ({
  field,
  form,
  icon,
  disabled,
  placeholder,
  type,
  ...props
}) => {
  const hasError = form && form.touched[field.name] && form.errors[field.name];

  return (
    <InputGroup>
      <InputGroupText
        className={`input-icon-prefix ${disabled ? 'disabled-icon' : ''}`}
      >
        {icon}
      </InputGroupText>
      <Input
        {...field}
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        invalid={!!hasError}
        {...props}
      />
      {hasError && <FormFeedback>{form.errors[field.name]}</FormFeedback>}
    </InputGroup>
  );
};

const RegularInput = ({
  field,
  form,
  disabled,
  placeholder,
  type,
  ...props
}) => {
  const hasError = form && form.touched[field.name] && form.errors[field.name];

  return (
    <>
      <Input
        {...field}
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        invalid={!!hasError}
        {...props}
      />
      {hasError && <FormFeedback>{form.errors[field.name]}</FormFeedback>}
    </>
  );
};

const CommissionForm = ({
  item,
  isEditable,
  handleEditToggle,
  initialValues,
  onSubmit,
  isCreate = false,
  showIcons = true,
}) => {
  return (
    <Formik
      initialValues={{ ...initialValues, isCreate }}
      onSubmit={(values, formikBag) => {
        if (isEditable && !isCreate) {
          onSubmit(values, item.id);
        } else if (isCreate) {
          onSubmit(values, formikBag);
        }
      }}
      validationSchema={validationSchema}
      validateOnChange={true}
      validateOnBlur={true}
    >
      {({ submitForm, errors, isSubmitting }) => (
        <FormikForm>
          {isCreate && <AutoCalculateSlabRange />}
          <FormGroup
            className={isCreate ? 'create-form-group' : 'custom-form-group'}
          >
            <div className="form-inputs">
              <div className="first-input">
                <div className="item">
                  <p className="label">
                    {isCreate ? 'Enter Slab Range' : 'Slab Range'}
                  </p>
                  {showIcons && !isCreate ? (
                    <Field
                      name="slabRange1"
                      component={IconInput}
                      icon="<"
                      placeholder={isCreate ? 'Ex: < 1,00,000' : ''}
                      disabled={!isCreate && !isEditable}
                    />
                  ) : (
                    <Field
                      name="slabRange1"
                      component={RegularInput}
                      placeholder={isCreate ? 'Ex: < 1,00,000' : ''}
                      disabled={!isCreate && !isEditable}
                    />
                  )}
                </div>
                <div className="item">
                  <p className="label">
                    RATE <span className="rate-unit">(p/kg)</span>
                    <span className="asterisk">&nbsp;*</span>
                  </p>
                  <Field
                    name="minRate"
                    component={IconInput}
                    icon={<BsCurrencyRupee />}
                    type="number"
                    placeholder={isCreate ? 'Enter Rate' : ''}
                    disabled={!isCreate && !isEditable}
                  />
                </div>
              </div>
              <div className="second-input">
                <div className="item">
                  {showIcons && !isCreate ? (
                    <Field
                      name="slabRange2"
                      component={IconInput}
                      icon=""
                      placeholder={isCreate ? 'Auto-calculated range' : ''}
                      disabled={true}
                    />
                  ) : (
                    <Field
                      name="slabRange2"
                      component={RegularInput}
                      placeholder={isCreate ? 'Auto-calculated range' : ''}
                      disabled={true}
                    />
                  )}
                </div>
                <div className="item">
                  <Field
                    name="midRate"
                    component={IconInput}
                    icon={<BsCurrencyRupee />}
                    type="number"
                    placeholder={isCreate ? 'Enter Rate' : ''}
                    disabled={!isCreate && !isEditable}
                  />
                </div>
              </div>
              <div className="third-input">
                <div className="item">
                  {showIcons && !isCreate ? (
                    <Field
                      name="slabRange3"
                      component={IconInput}
                      icon=">"
                      placeholder={isCreate ? 'Ex: > 5,00,000' : ''}
                      disabled={!isCreate && !isEditable}
                    />
                  ) : (
                    <Field
                      name="slabRange3"
                      component={RegularInput}
                      placeholder={isCreate ? 'Ex: > 5,00,000' : ''}
                      disabled={!isCreate && !isEditable}
                    />
                  )}
                </div>
                <div className="item">
                  <Field
                    name="maxRate"
                    component={IconInput}
                    icon={<BsCurrencyRupee />}
                    type="number"
                    placeholder={isCreate ? 'Enter Rate' : ''}
                    disabled={!isCreate && !isEditable}
                  />
                </div>
              </div>
            </div>
            <div className="action_btn_container d-flex justify-content-end">
              {isCreate ? (
                <Button
                  className="create-btn"
                  color="warning"
                  type="button"
                  onClick={() => submitForm()}
                  disabled={isSubmitting}
                >
                  <BsPlus className="plus-icon" /> Create
                </Button>
              ) : (
                <Button
                  className="action_btn"
                  color="primary"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    if (isEditable) {
                      submitForm();
                    } else {
                      handleEditToggle(item.id);
                    }
                  }}
                  disabled={isSubmitting}
                >
                  {!isEditable && <BsFillPencilFill className="pencil-icon" />}
                  <span>{!isEditable ? 'Edit' : 'Save'}</span>
                </Button>
              )}
            </div>

            {errors.submit && (
              <div className="text-danger mt-2">{errors.submit}</div>
            )}
          </FormGroup>
        </FormikForm>
      )}
    </Formik>
  );
};

const IndianBuyerCommission = () => {
  const { auth } = useContext(authContext);
  const [commissionData, setCommissionData] = useState([]);
  const [defaultOpen, setDefaultOpen] = useState(null);
  const [createOpen, setCreateOpen] = useState('');
  const [nonDefaultOpen, setNonDefaultOpen] = useState('');
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState('');
  const [editMode, setEditMode] = useState({});

  const fetchCommissionData = () => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_REST_API_ENDPOINT}commission/fetch-all-commission-slabs-Buyer`,
        {
          headers: {
            Authorization: `Bearer ${auth?.data?.token}`,
          },
        },
      )
      .then((response) => {
        if (response.data && response.data.data) {
          setCommissionData(response.data.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching Indian Buyer Commission data:', err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (auth?.data?.token) {
      fetchCommissionData();
    }
  }, [auth?.data?.token]);

  const toggleDefault = (id) => {
    setDefaultOpen(defaultOpen === id ? '' : id);
  };

  const toggleCreate = (id) => {
    setCreateOpen(createOpen === id ? '' : id);
    setFormError('');
  };

  const toggleNonDefault = (id) => {
    setNonDefaultOpen(nonDefaultOpen === id ? '' : id);
  };

  const handleEditToggle = (id) => {
    const numericId = Number(id);
    setEditMode((prevState) => ({
      ...prevState,
      [numericId]: !prevState[numericId],
    }));
  };

  const handleSubmit = async (values, id) => {
    setLoading(true);
    setFormError('');

    const minWeight = parseInt(
      values.slabRange1.toString().replace(/,/g, ''),
      10,
    );
    const maxWeight = parseInt(
      values.slabRange3.toString().replace(/,/g, ''),
      10,
    );

    if (minWeight >= maxWeight) {
      setFormError('Max weight must be greater than min weight');
      setLoading(false);
      return;
    }

    const commissionItem = commissionData.find((item) => item.id === id);

    const payload = {
      id,
      commissionTypeName: commissionItem
        ? commissionItem.commissionTypeName
        : `Type ${commissionData.filter((item) => !item.isDefault).length + 1}`,
      commissionCategory: 'INDIAN_BUYER',
      minWeight,
      maxWeight,
      leastRangeRate: parseFloat(values.minRate),
      midRangeRate: parseFloat(values.midRate),
      maxRangeRate: parseFloat(values.maxRate),
    };

    try {
      await axios.post(
        `${process.env.REACT_APP_REST_API_ENDPOINT}commission/add-edit-indian-buyer-commission-slab`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${auth?.data?.token}`,
          },
        },
      );
      toast.success('Buyer commission updated successfully');
      fetchCommissionData();
      handleEditToggle(id);
    } catch (error) {
      console.error('Error updating commission:', error);
      toast.error('Failed to update commission');
      setFormError('Failed to update commission. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    setFormError('');

    const minWeight = parseInt(
      values.slabRange1.toString().replace(/,/g, ''),
      10,
    );
    const maxWeight = parseInt(
      values.slabRange3.toString().replace(/,/g, ''),
      10,
    );

    if (minWeight >= maxWeight) {
      setFormError('Max weight must be greater than min weight');
      setSubmitting(false);
      setLoading(false);
      return;
    }

    const payload = {
      id: null,
      commissionTypeName: `Type ${commissionData.filter((item) => !item.isDefault).length + 1}`,
      commissionCategory: 'INDIAN_BUYER',
      minWeight,
      maxWeight,
      leastRangeRate: parseFloat(values.minRate),
      midRangeRate: parseFloat(values.midRate),
      maxRangeRate: parseFloat(values.maxRate),
    };

    try {
      await axios.post(
        `${process.env.REACT_APP_REST_API_ENDPOINT}commission/add-edit-indian-buyer-commission-slab`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${auth?.data?.token}`,
          },
        },
      );
      toast.success('Buyer commission created successfully');
      fetchCommissionData();
      setCreateOpen('');
    } catch (error) {
      console.error('Error creating commission:', error);
      toast.error('Failed to create commission');
      setFormError('Failed to create commission. Please try again.');
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  const defaultCommissions = commissionData.filter((item) =>
    item.commissionTypeName?.toLowerCase().includes('global commission'),
  );
  const nonDefaultCommissions = commissionData.filter(
    (item) => !item.commissionTypeName?.toLowerCase().includes('global commission'),
  );

  const renderDefaultAccordions = () => (
    <Accordion open={defaultOpen} toggle={toggleDefault}>
      {defaultCommissions.map((item) => (
        <AccordionItem key={item.id}>
          <AccordionHeader targetId={String(item.id)}>
            {item.commissionTypeName?.toUpperCase() || 'GLOBAL COMMISSION BUYER'}
          </AccordionHeader>
          <AccordionBody accordionId={String(item.id)}>
            <CommissionForm
              item={item}
              isEditable={Boolean(editMode[item.id])}
              handleEditToggle={handleEditToggle}
              initialValues={{
                slabRange1: item.minWeight,
                minRate: item.leastRangeRate,
                slabRange2: `${item.minWeight} - ${item.maxWeight}`,
                midRate: item.midRangeRate,
                slabRange3: item?.maxWeight,
                maxRate: item.maxRangeRate,
              }}
              onSubmit={handleSubmit}
              showIcons={true}
            />
          </AccordionBody>
        </AccordionItem>
      ))}
    </Accordion>
  );

  const renderCreateAccordion = () => (
    <Accordion open={createOpen} toggle={toggleCreate}>
      <AccordionItem>
        <AccordionHeader targetId="create">
          CREATE NEW COMMISSION TYPE
        </AccordionHeader>
        <AccordionBody accordionId="create">
          {formError && <div className="alert alert-danger">{formError}</div>}
          <CommissionForm
            isEditable={true}
            isCreate={true}
            item={{}}
            handleEditToggle={() => {}}
            initialValues={{
              slabRange1: '',
              minRate: '',
              slabRange2: '',
              midRate: '',
              slabRange3: '',
              maxRate: '',
            }}
            onSubmit={handleCreateSubmit}
            showIcons={true}
          />
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  );

  const renderNonDefaultAccordions = () => (
    <Accordion open={nonDefaultOpen} toggle={toggleNonDefault}>
      {nonDefaultCommissions.map((item) => (
        <AccordionItem key={item.id}>
          <AccordionHeader targetId={String(item.id)}>
            {item.commissionTypeName.toUpperCase()}
          </AccordionHeader>
          <AccordionBody accordionId={String(item.id)}>
            <CommissionForm
              item={item}
              isEditable={Boolean(editMode[item.id])}
              handleEditToggle={handleEditToggle}
              initialValues={{
                slabRange1: item.minWeight,
                minRate: item.leastRangeRate,
                slabRange2: `${item.minWeight} - ${item.maxWeight}`,
                midRate: item.midRangeRate,
                slabRange3: item?.maxWeight,
                maxRate: item.maxRangeRate,
              }}
              onSubmit={handleSubmit}
              showIcons={true}
            />
          </AccordionBody>
        </AccordionItem>
      ))}
    </Accordion>
  );

  useEffect(() => {
    if (defaultCommissions.length > 0 && defaultOpen === null) {
      setDefaultOpen(String(defaultCommissions[0].id));
    }
  }, [defaultCommissions, defaultOpen]);

  return (
    <div className="commission-container-wrapper">
      {loading && <div className="text-center py-3">Processing request...</div>}

      <Card className="border shadow-none mb-4">
        <CardBody className="p-4">
          <div className="commission-container">
            {renderDefaultAccordions()}
            <hr />
            {renderCreateAccordion()}
            <hr />
            {renderNonDefaultAccordions()}
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default IndianBuyerCommission;
